import { $ as e, C as t, D as n, E as r, F as i, H as a, J as o, L as s, O as c, Q as l, R as u, S as d, U as f, Z as p, _ as m, at as h, f as ee, g, h as _, i as v, k as te, l as ne, m as y, n as re, nt as b, ot as x, p as S, q as C, r as ie, rt as w, t as T, v as E, w as D, x as ae, z as oe } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as O, t as k } from "./i18n-lite-BcmwMblk.js";
import { t as se } from "./normalize-props-DNjMoRjC.js";
import { n as A, r as ce, t as j } from "./Cross.ce-B3B4wiAB.js";
import { t as le } from "./shadow-dom-9FbsLIC0.js";
import { t as ue } from "./Popin.ce-aq5qU85Q.js";
//#region src/webcomponents/trouver-mdp-rs/locales/de-AT.json
var de = {}, fe = {}, pe = {}, me = {}, he = {}, ge = { "trouver-mdp-rs": {
	connection: "Connexion",
	login: "Identifiant",
	password: "Mot de passe",
	submitButton: "Se connecter",
	retryButtonLabel: "Réessayer",
	userProfile: {
		subscriptions: "{count} abonnements",
		followers: "{count} abonnés"
	}
} }, _e = {}, ve = {}, M = Object.defineProperty, ye = (e, t) => {
	let n = {};
	for (var r in e) M(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t && M(n, Symbol.toStringTag, { value: "Module" }), n;
}, N = e([]), P = e(null), F = e(null), I = e(null), L = e(null), R = p({ current: "" }), z = [], be = e(!1), B = l(N), xe = l(P), Se = l(F), Ce = l(I), we = l(L), V = l(R), Te = (e) => {
	N.value = e;
}, Ee = (e) => {
	P.value = e;
}, De = (e) => {
	F.value = e;
}, Oe = (e) => {
	I.value = e;
}, ke = (e) => {
	L.value = e;
}, H = (e = xe.value) => {
	R.current = e;
	let t = B.value.findIndex((t) => t.name === e), n = B.value.map((e) => e.name);
	for (let r = 0; r < n.length; r++) {
		if (r > 0 && r < n.length - 1) {
			let e = n[r] + "Minus", i = n[r] + "Plus";
			R[e] = t <= r, R[i] = t >= r;
		}
		R[n[r]] = n[r] === e;
	}
}, Ae = () => {
	let e = Object.keys(R);
	for (let t of e) delete R[t];
	H(), U(), W(), G();
}, U = (e = Se.value) => {
	R.orientation = e, R.isLandscape = e === "landscape", R.isPortrait = e === "portrait";
}, W = (e = Ce.value || "light") => {
	R.theme = e, R.isDark = e === "dark", R.isLight = e === "light";
}, G = (e = we.value || "no-preference") => {
	R.motionPreference = e, R.isMotion = e === "no-preference", R.isInert = e === "reduce";
};
function je() {
	for (; z.length > 0;) {
		let e = z.shift();
		if (e && typeof e == "object") {
			let { mql: t, cb: n } = e;
			t.addEventListener && typeof t.addEventListener == "function" ? t.removeEventListener("change", n) : t.removeListener(n);
		}
	}
}
function Me() {
	return B.value.reduce((e, t, n, r) => {
		let i = `(min-width: ${t.min}px)`, a = n < r.length - 1 ? `(max-width: ${r[n + 1].min - 1}px)` : null, o = i + (a ? " and " + a : "");
		return Object.assign(e, { [t.name]: o });
	}, {});
}
function K(e, t) {
	if (typeof window > "u" || !window.matchMedia) return !1;
	if (typeof window < "u" && !window.matchMedia) return console.error("Vue3 Mq: No MatchMedia support detected in this browser. Responsive breakpoints not available."), !1;
	{
		be.value = !0;
		let n = window.matchMedia(e), r = ({ matches: e }) => {
			e && t();
		};
		z.push({
			mql: n,
			cb: r
		}), n.addEventListener && typeof n.addEventListener == "function" ? n.addEventListener("change", r) : n.addListener(r), r(n);
	}
}
var q = (e) => B.value.some((t) => t.name === e), J = (e, t) => {
	let n = t.value.map((e) => e.name);
	if (e) {
		if (Array.isArray(e)) return e.filter((e) => q(e));
		if (typeof e == "string" && /\w+\+$/.test(e)) {
			if (e = e.replace(/\+$/, ""), q(e) === !1) return console.error(`Vue3 Mq: ${e} is not a valid breakpoint key. Invalid range.`), n;
			let r = t.value.findIndex((t) => t.name === e);
			return t.value.slice(r).map((e) => e.name);
		}
		if (typeof e == "string" && /\w+-$/.test(e)) {
			if (e = e.replace(/-$/, ""), q(e) === !1) return console.error(`Vue3 Mq: ${e} is not a valid breakpoint key. Invalid range.`), n;
			let r = t.value.findIndex((t) => t.name === e);
			return t.value.slice(0, r + 1).map((e) => e.name);
		}
		if (typeof e == "string" && /^\w+-\w+$/.test(e)) {
			let [r, i] = e.split("-");
			if (q(r) === !1) return console.error(`Vue3 Mq: ${r} is not a valid breakpoint key. Invalid range.`), n;
			if (q(i) === !1) return console.error(`Vue3 Mq: ${i} is not a valid breakpoint key. Invalid range.`), n;
			let a = t.value.findIndex((e) => e.name === r), o = t.value.findIndex((e) => e.name === i);
			return t.value.slice(a, o + 1).map((e) => e.name);
		}
		return typeof e == "string" && q(e) === !0 ? [e] : n;
	}
	return n;
}, Y = (e, t) => {
	let n = [];
	return !e && !t ? ["landscape", "portrait"] : (e && n.push("landscape"), t && n.push("portrait"), n);
}, X = (e, t) => {
	let n = [];
	return !t && !e ? ["light", "dark"] : (t && n.push("light"), e && n.push("dark"), n);
}, Z = (e, t) => {
	let n = [];
	return !e && !t ? ["reduce", "no-preference"] : (e && n.push("reduce"), t && n.push("no-preference"), n);
}, Q = /* @__PURE__ */ ye({
	bootstrap3: () => Fe,
	bootstrap4: () => Pe,
	bootstrap5: () => Ne,
	bulma: () => Ue,
	devices: () => Be,
	mui: () => He,
	tailwind: () => ze,
	vuetify: () => Re,
	vuetify3: () => Le,
	vuetify4: () => Ie,
	wordpress: () => Ve
}, 1), Ne = {
	xs: 0,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200,
	xxl: 1400
}, Pe = {
	xs: 0,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200
}, Fe = {
	xs: 0,
	sm: 768,
	md: 992,
	lg: 1200
}, Ie = {
	xs: 0,
	sm: 600,
	md: 840,
	lg: 1145,
	xl: 1545,
	xxl: 2138
}, Le = {
	xs: 0,
	sm: 600,
	md: 960,
	lg: 1280,
	xl: 1920,
	xxl: 2560
}, Re = {
	xs: 0,
	sm: 600,
	md: 960,
	lg: 1264,
	xl: 1904
}, ze = {
	xs: 0,
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	xxl: 1536
}, Be = {
	phone: 0,
	tablet: 768,
	laptop: 1370,
	desktop: 1906
}, Ve = {
	mobile: 0,
	small: 600,
	medium: 782,
	large: 960,
	xlarge: 1080,
	wide: 1280,
	huge: 1440
}, He = {
	xs: 0,
	sm: 600,
	md: 900,
	lg: 1200,
	xl: 1536
}, Ue = {
	mobile: 0,
	tablet: 768,
	desktop: 1024,
	widescreen: 1216,
	fullhd: 1408
}, We = (e) => {
	if (typeof e == "string" && Q[e]) return Q[e];
	{
		let t = Object.keys(Q);
		return console.error(`Vue3 Mq: "${e}" is not a valid preset. Available options are: ${t.join(", ")}`), !1;
	}
}, Ge = (e) => ["landscape", "portrait"].includes(e) === !1 ? (console.error(`Vue3 Mq: "${e}" is not a valid default orientation. Reverting to unset value.`), null) : e, Ke = (e = null) => ["dark", "light"].includes(e) === !1 && e !== null ? (console.error(`Vue3 Mq: "${e}" is not a valid default theme. Reverting to unset value.`), null) : e, qe = (e = null) => ["no-preference", "reduce"].includes(e) === !1 && e !== null ? (console.error(`Vue3 Mq: "${e}" is not a valid default motion preference. Reverting to unset value.`), null) : e, $ = (e) => {
	if (!e || typeof e != "object") return !1;
	let t = [];
	for (let n in e) {
		let r = parseFloat(e[n]);
		if (!n || typeof n != "string") {
			console.warn(`Vue3 Mq: Invalid or missing breakpoint key (${JSON.stringify(n)}). Skipping.`);
			continue;
		}
		if (/^[^a-z]/i.test(n) || /[^a-zA-Z0-9_]/.test(n)) {
			console.warn(`Vue3 Mq: "${n}" is an invalid breakpoint key. Breakpoint keys must start with a letter and contain only alphanumeric characters and underscores. Skipping.`);
			continue;
		}
		if (!r && r !== 0 || isNaN(r) || r < 0) {
			console.warn(`Vue3 Mq: "${n}: ${e[n]}" is not a valid breakpoint. Breakpoints should be a number of zero or above. Skipping.`);
			continue;
		}
		t.push({
			name: n,
			min: r
		});
	}
	return t.some((e) => e.min === 0) || console.warn("Vue3 Mq: You have not declared a breakpoint with a minimum value of 0. There may be screen sizes to which Vue3Mq does not respond."), new Set(t.map((e) => e.min)).size < t.length && console.warn("Vue3 Mq: Your breakpoint configuration contains duplicate values. Behaviour may be unpredictable."), t.length !== 0 && t.sort((e, t) => e.min - t.min);
}, Je = (e) => {
	let t = e.split(":"), n = {};
	for (let e of t) if (/\D/.test(e) === !1) continue;
	else ["landscape", "portrait"].includes(e) ? n.slotOrientation = e : ["light", "dark"].includes(e) ? n.slotTheme = e : ["inert", "motion"].includes(e) ? n.slotMotion = e : n.slotBp = e;
	return n;
}, Ye = {
	name: "fade",
	mode: "out-in"
}, Xe = {
	name: "MqResponsive",
	props: {
		target: [String, Array],
		landscape: {
			type: Boolean,
			default: !1
		},
		portrait: {
			type: Boolean,
			default: !1
		},
		dark: {
			type: Boolean,
			default: !1
		},
		light: {
			type: Boolean,
			default: !1
		},
		inert: {
			type: Boolean,
			default: !1
		},
		motion: {
			type: Boolean,
			default: !1
		},
		tag: {
			type: String,
			default: "div"
		},
		listTag: {
			type: String,
			default: "div"
		},
		group: {
			type: Boolean,
			default: !1
		}
	},
	setup(e, { attrs: t, emit: n, slots: i }) {
		let a = y(() => J(e.target, B)), o = y(() => Y(e.landscape, e.portrait)), s = y(() => X(e.dark, e.light)), c = y(() => Z(e.inert, e.motion)), l = y(() => a.value.includes(V.current) && o.value.includes(V.orientation) && s.value.includes(V.theme) && c.value.includes(V.motionPreference)), u = (t) => {
			if (!e.group && i.length > 0) return i;
			let n = [];
			for (let e in i) {
				let { slotBp: a, slotOrientation: o, slotTheme: s, slotMotion: c } = Je(e), l = y(() => J(a, B)), u = y(() => Y(o === "landscape", o === "portrait")), d = y(() => X(s === "dark", s === "light")), f = y(() => Z(c === "inert", c === "motion"));
				y(() => l.value.includes(V.current) && u.value.includes(V.orientation) && d.value.includes(V.theme) && f.value.includes(V.motionPreference)).value === !0 && n.push(r(t || i[e], { key: e }, t ? i[e]() : void 0));
			}
			return n.length > 0 ? n : void 0;
		};
		return i.default ? () => l.value ? r(e.tag, { ...t }, i.default()) : void 0 : () => {
			let n = Object.assign({}, Ye, t, { tag: e.tag });
			return r(e.group ? ie : re, n, () => u(e.listTag));
		};
	}
};
function Ze({ breakpoints: e, mergeBreakpoints: t = {}, preset: n }) {
	let r = n ? We(n) : !1, i = e ? $(e) : !1;
	if (r === !1 && !i) throw TypeError("Vue3 Mq: You must provide a valid preset, or valid breakpoint settings.");
	Te(i || $({
		...r,
		...t
	})), je(), Ae();
	let a = Me();
	for (let e in a) {
		let t = a[e];
		K(t, () => {
			H(e);
		});
	}
	["portrait", "landscape"].forEach((e) => {
		K(`(orientation: ${e})`, () => {
			U(e);
		});
	}), ["light", "dark"].forEach((e) => {
		K(`(prefers-color-scheme: ${e})`, () => {
			W(e);
		});
	}), ["reduce", "no-preference"].forEach((e) => {
		K(`(prefers-reduced-motion: ${e})`, () => {
			G(e);
		});
	});
}
function Qe() {
	let e = n("mq");
	if (e) return e;
	throw Error("Vue3Mq is not installed in this app. Please follow the installation instructions and try again.");
}
var $e = { install: (e, { preset: t = "bootstrap5", breakpoints: n, mergeBreakpoints: r, defaultBreakpoint: i, defaultOrientation: a = "landscape", defaultMotion: o = "no-preference", defaultTheme: s, global: c = !1 } = {}) => {
	try {
		let l = Ge(a), u = Ke(s), d = qe(o);
		Ee(i), De(l), Oe(u), ke(d), e.provide("mq", V), e.provide("updateBreakpoints", Ze), c === !0 && (e.component("MqResponsive", Xe), e.config.globalProperties.$mq = V), Ze({
			breakpoints: n,
			mergeBreakpoints: r,
			preset: t
		});
	} catch (e) {
		console.error(e);
	}
} }, et = "data:image/svg+xml,%3csvg%20width='34'%20height='34'%20viewBox='0%200%2034%2034'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%2017C0%207.61116%207.61116%200%2017%200C26.3888%200%2034%207.61116%2034%2017C34%2026.3888%2026.3888%2034%2017%2034C7.61116%2034%200%2026.3888%200%2017Z'%20fill='%232C75FF'/%3e%3cpath%20d='M17%2019.25V20.75M12.5%2023.75H21.5C21.8978%2023.75%2022.2794%2023.592%2022.5607%2023.3107C22.842%2023.0294%2023%2022.6478%2023%2022.25V17.75C23%2017.3522%2022.842%2016.9706%2022.5607%2016.6893C22.2794%2016.408%2021.8978%2016.25%2021.5%2016.25H12.5C12.1022%2016.25%2011.7206%2016.408%2011.4393%2016.6893C11.158%2016.9706%2011%2017.3522%2011%2017.75V22.25C11%2022.6478%2011.158%2023.0294%2011.4393%2023.3107C11.7206%2023.592%2012.1022%2023.75%2012.5%2023.75ZM20%2016.25V13.25C20%2012.4544%2019.6839%2011.6913%2019.1213%2011.1287C18.5587%2010.5661%2017.7956%2010.25%2017%2010.25C16.2044%2010.25%2015.4413%2010.5661%2014.8787%2011.1287C14.3161%2011.6913%2014%2012.4544%2014%2013.25V16.25H20Z'%20stroke='white'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", tt = ["aria-level"], nt = ["src"], rt = { class: "login-form__field" }, it = { for: "user" }, at = { class: "login-form__field__input-container is-disabled" }, ot = ["value"], st = { class: "login-form__field" }, ct = { for: "password" }, lt = ["readonly"], ut = ["innerHTML"], dt = ["innerHTML"], ft = ["aria-disabled"], pt = /*#__PURE__*/ T(/* @__PURE__ */ D({
	__name: "LoginForm.ce",
	props: /*@__PURE__*/ c({
		titleLevel: { type: Number },
		validations: { type: Object },
		currentFeedback: { type: Object }
	}, {
		password: {},
		passwordModifiers: {},
		currentFeedbackType: {},
		currentFeedbackTypeModifiers: {}
	}),
	emits: ["update:password", "update:currentFeedbackType"],
	setup(e) {
		let { i18next: n } = O(), r = Qe(), s = a(e, "password"), c = a(e, "currentFeedbackType"), l = f("passwordInput");
		function u() {
			let t = e.validations.password.localeCompare(s.value, n.language, { sensitivity: "base" }) === 0;
			c.value = t ? "success" : "failure", !t && l.value.focus();
		}
		let p = y(() => c.value === "success"), h = y(() => c.value === "failure"), v = y(() => e.currentFeedback !== void 0 && !r.phone);
		return (n, r) => (i(), E("form", {
			class: "login-form",
			onSubmit: r[1] ||= ee((e) => u(), ["prevent"])
		}, [
			_("div", {
				role: "heading",
				"aria-level": e.titleLevel,
				class: "login-form__title"
			}, [_("img", {
				src: b(et),
				alt: ""
			}, null, 8, nt), d(" " + x(n.$t("trouver-mdp-rs.connection")), 1)], 8, tt),
			_("div", rt, [_("label", it, x(n.$t("trouver-mdp-rs.login")), 1), _("div", at, [_("input", {
				id: "user",
				value: e.validations.user,
				readonly: "",
				class: "is-disabled"
			}, null, 8, ot)])]),
			_("div", st, [_("label", ct, x(n.$t("trouver-mdp-rs.password")), 1), _("div", { class: w(["login-form__field__input-container", {
				"is-error": h.value,
				"is-success": p.value,
				"is-disabled": p.value
			}]) }, [
				o(_("input", {
					id: "password",
					ref_key: "passwordInput",
					ref: l,
					"onUpdate:modelValue": r[0] ||= (e) => s.value = e,
					readonly: p.value
				}, null, 8, lt), [[ne, s.value]]),
				p.value ? (i(), g(A, {
					key: 0,
					color: "#007740",
					class: "login-form__field__icon"
				})) : m("", !0),
				h.value ? (i(), g(j, {
					key: 1,
					class: "login-form__field__icon",
					color: "#A94B0C"
				})) : m("", !0)
			], 2)]),
			t(ce, { "display-feedback": v.value }, {
				icon: C(() => [p.value ? (i(), g(A, { key: 0 })) : m("", !0), h.value ? (i(), g(j, { key: 1 })) : m("", !0)]),
				title: C(() => [_("span", { innerHTML: e.currentFeedback.title }, null, 8, ut)]),
				content: C(() => [_("span", { innerHTML: e.currentFeedback.content }, null, 8, dt)]),
				_: 1
			}, 8, ["display-feedback"]),
			_("button", {
				type: "submit",
				"aria-disabled": p.value,
				class: w({ "is-disabled": p.value })
			}, x(n.$t("trouver-mdp-rs.submitButton")), 11, ft)
		], 32));
	}
}), [["styles", [".login-form[data-v-dd2f63bf]{background:#fff;border-radius:.875rem;flex-direction:column;flex:1;gap:1rem;height:fit-content;padding:1.56rem;display:flex;box-shadow:0 2px 5px #2c75ff40,inset 0 -2px 5px #2c75ff26,inset 0 1px 1px #ffffff1a,inset 0 3px 4px #dfeeff1a}.login-form__title[data-v-dd2f63bf]{align-items:center;gap:.5rem;margin-bottom:.5rem;font-family:Nunito,sans-serif;font-size:1.25rem;font-weight:700;line-height:1.75rem;display:flex}.login-form__field[data-v-dd2f63bf]{flex-direction:column;display:flex}.login-form__field label[data-v-dd2f63bf]{color:#5e6c84;font-size:.875rem;line-height:1.25rem}.login-form__field__icon[data-v-dd2f63bf]{width:16px;height:16px}.login-form__field__input-container[data-v-dd2f63bf]{background:#f4f5f7;border:1px solid #cdd1d9;border-radius:10px;align-items:center;padding:.75rem 1rem;display:flex}.login-form__field__input-container input[data-v-dd2f63bf]{background:0 0;border:none;width:100%}.login-form__field__input-container input[data-v-dd2f63bf]:focus{border:none;outline:none}.login-form__field__input-container input.is-disabled[data-v-dd2f63bf]{cursor:not-allowed}.login-form__field__input-container.is-error[data-v-dd2f63bf]{background:#fbebea;border:1px solid #d73328}.login-form__field__input-container.is-success[data-v-dd2f63bf]{background:#e6f6ef;border:1px solid #00a85a}.login-form__field__input-container.is-disabled[data-v-dd2f63bf]{cursor:not-allowed}.login-form__field__input-container[data-v-dd2f63bf]:focus-within{outline:2px solid #000}.login-form button[data-v-dd2f63bf]{cursor:pointer;text-wrap:nowrap;text-align:center;color:#fff;background:#122647;border:none;border-radius:10px;width:100%;padding:.75rem;font-size:1rem}.login-form button.is-disabled[data-v-dd2f63bf]{cursor:not-allowed;background:#cdd1d9;border:none}@media screen and (width<=769px){.login-form[data-v-dd2f63bf]{z-index:10;background:#fff;border-radius:14px;box-shadow:0 -20px 60px -15px #2c75ff26}}"]], ["__scopeId", "data-v-dd2f63bf"]]), mt = "data:image/webp;base64,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", ht = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.00016%204.66658C6.7135%204.66658%205.66683%205.71325%205.66683%206.99992C5.66683%208.28658%206.7135%209.33325%208.00016%209.33325C9.28683%209.33325%2010.3335%208.28658%2010.3335%206.99992C10.3335%205.71325%209.28683%204.66658%208.00016%204.66658ZM8.00016%207.99992C7.44883%207.99992%207.00016%207.55125%207.00016%206.99992C7.00016%206.44859%207.44883%205.99992%208.00016%205.99992C8.5515%205.99992%209.00016%206.44859%209.00016%206.99992C9.00016%207.55125%208.5515%207.99992%208.00016%207.99992ZM8.00016%201.33325C4.8755%201.33325%202.3335%203.87525%202.3335%206.99992C2.3335%2010.9779%207.41416%2014.4106%207.63016%2014.5546L8.00016%2014.8013L8.37016%2014.5546C8.58616%2014.4106%2013.6668%2010.9779%2013.6668%206.99992C13.6668%203.87525%2011.1248%201.33325%208.00016%201.33325ZM8.00016%2013.1799C6.89016%2012.3526%203.66683%209.71592%203.66683%206.99992C3.66683%204.61058%205.61083%202.66659%208.00016%202.66659C10.3895%202.66659%2012.3335%204.61058%2012.3335%206.99992C12.3335%209.71525%209.11016%2012.3519%208.00016%2013.1799Z'%20fill='%235E6C84'/%3e%3c/svg%3e", gt = { class: "header" }, _t = ["src"], vt = { class: "header__user" }, yt = { class: "header__user__name" }, bt = { class: "header__user__tag" }, xt = { class: "user-profile" }, St = { class: "user-profile__location" }, Ct = ["src"], wt = { class: "user-profile__metadata" }, Tt = ["aria-setsize"], Et = [
	"aria-posinset",
	"aria-labeledby",
	"aria-describedby"
], Dt = ["aria-level"], Ot = { class: "article__header__user-container" }, kt = ["src"], At = { class: "article__header__user" }, jt = { class: "article__header__user__name" }, Mt = { class: "article__header__user__tag" }, Nt = ["datetime"], Pt = /*#__PURE__*/ T(/* @__PURE__ */ D({
	__name: "SocialNetwork.ce",
	props: {
		userName: { type: String },
		tag: { type: String },
		bio: { type: String },
		location: { type: String },
		publications: { type: Array },
		titleLevel: { type: Number }
	},
	setup(e) {
		let { i18next: n } = O();
		function r(e) {
			return Intl.DateTimeFormat(n.language).format(new Date(e));
		}
		return (n, a) => {
			let o = oe("i18next");
			return i(), E(S, null, [
				_("header", gt, [_("img", {
					src: b(mt),
					alt: ""
				}, null, 8, _t), _("div", vt, [_("span", yt, x(e.userName), 1), _("span", bt, x(e.tag), 1)])]),
				_("section", xt, [
					_("p", null, x(e.bio), 1),
					_("div", St, [_("img", {
						src: b(ht),
						alt: ""
					}, null, 8, Ct), _("p", null, x(e.location), 1)]),
					_("div", wt, [_("p", null, [t(o, { translation: n.$t("trouver-mdp-rs.userProfile.followers") }, {
						count: C(() => [...a[0] ||= [_("span", { class: "user-profile__metadata__number" }, "146", -1)]]),
						_: 1
					}, 8, ["translation"])]), _("p", null, [t(o, { translation: n.$t("trouver-mdp-rs.userProfile.subscriptions") }, {
						count: C(() => [...a[1] ||= [_("span", { class: "user-profile__metadata__number" }, "146", -1)]]),
						_: 1
					}, 8, ["translation"])])])
				]),
				_("section", {
					role: "feed",
					"aria-busy": "false",
					"aria-setsize": e.publications.length,
					class: "feed-container"
				}, [(i(!0), E(S, null, s(e.publications, (t, n) => (i(), E("article", {
					key: e.tag + n,
					"aria-posinset": n,
					"aria-labeledby": e.userName,
					"aria-describedby": t.content,
					"aria-busy": "false",
					tabindex: "0",
					role: "article",
					class: "article"
				}, [_("div", {
					role: "heading",
					"aria-level": e.titleLevel + 2,
					class: "article__header"
				}, [_("address", Ot, [_("img", {
					src: b(mt),
					alt: ""
				}, null, 8, kt), _("div", At, [_("span", jt, x(e.userName), 1), _("span", Mt, x(e.tag), 1)])]), _("time", {
					class: "article__header__date",
					datetime: t.date
				}, x(r(t.date)), 9, Nt)], 8, Dt), _("p", null, x(t.content), 1)], 8, Et))), 128))], 8, Tt)
			], 64);
		};
	}
}), [["styles", [".header[data-v-277e291f]{background:linear-gradient(90deg,#2b7fff26 0%,#00b8db26 100%);border-radius:1.5rem 1.5rem 0 0;align-items:flex-start;gap:8px;padding:1.687rem 2rem 1.188rem 1rem;display:flex}.header img[data-v-277e291f]{width:50px}.header__user[data-v-277e291f]{flex-direction:column;display:flex}.header__user__name[data-v-277e291f]{font-family:Nunito,sans-serif;font-size:1.125rem;font-weight:700;line-height:1.56rem}.header__user__tag[data-v-277e291f]{color:#5e6c84;font-size:.875rem;font-weight:400;line-height:1.25rem}.user-profile[data-v-277e291f]{flex-direction:column;gap:8px;padding:.25rem 1rem;font-size:.875rem;display:flex}.user-profile p[data-v-277e291f]{margin:0}.user-profile__location[data-v-277e291f]{color:#5e6c84;gap:.25rem;margin:0;font-weight:400;line-height:1.25rem;display:flex}.user-profile__metadata[data-v-277e291f]{gap:.75rem;display:flex}.user-profile__metadata__number[data-v-277e291f]{color:#122647;font-weight:700}.user-profile__metadata__text[data-v-277e291f]{color:#5e6c84;margin-left:.25rem;font-weight:400}.feed-container[data-v-277e291f]{flex-direction:column;align-items:center;gap:.625rem;padding:0 1rem;font-size:.875rem;display:flex;overflow:hidden auto}.feed-container .article[data-v-277e291f]{background:#fff;border:1px solid #cdd1d9;border-radius:1rem;flex-direction:column;gap:1rem;width:calc(100% - 2rem);padding:.5rem 1rem;display:flex}.feed-container .article p[data-v-277e291f]{margin:0}.feed-container .article__header[data-v-277e291f]{color:#5e6c84;justify-content:space-between;align-items:flex-start;gap:.5rem;font-size:.875rem;font-weight:400;line-height:1.25rem;display:flex}.feed-container .article__header__user-container[data-v-277e291f]{gap:4px;font-style:normal;display:flex}.feed-container .article__header__user-container img[data-v-277e291f]{width:35px;height:35px}.feed-container .article__header__user[data-v-277e291f]{flex-direction:column;display:flex}.feed-container .article__header__user__name[data-v-277e291f]{font-family:Nunito,sans-serif;font-weight:700}@media screen and (width<=769px){.header[data-v-277e291f]{border-radius:0}.feed-container[data-v-277e291f]{overflow:unset}}"]], ["__scopeId", "data-v-277e291f"]]), Ft = /*#__PURE__*/ T(/* @__PURE__ */ D({
	__name: "MobileShellWrapper.ce",
	props: {
		backgroundColor: { type: String },
		hasBorderBottom: { type: Boolean }
	},
	setup(e) {
		return (t, n) => (i(), E("div", {
			style: h({
				"--background-color": e.backgroundColor ?? "#f4f5f7",
				"--border-bottom": e.hasBorderBottom ? "10px solid black" : "none"
			}),
			class: "mobile-wrapper"
		}, [n[0] ||= ae("<div class=\"cache-top\" data-v-7b6a98ec><div class=\"camera\" data-v-7b6a98ec></div></div><div class=\"buttons\" data-v-7b6a98ec><div class=\"button small\" data-v-7b6a98ec></div><div class=\"button long\" data-v-7b6a98ec></div><div class=\"button long\" data-v-7b6a98ec></div></div>", 2), u(t.$slots, "content", {}, void 0, !0)], 4));
	}
}), [["styles", [".mobile-wrapper[data-v-7b6a98ec]{background:var(--background-color);height:inherit;border:10px solid #000;border-bottom:var(--border-bottom);border-radius:30px 30px 0 0;flex-direction:column;min-width:300px;display:flex;position:relative}.mobile-wrapper .cache-top[data-v-7b6a98ec]{z-index:6;background:#000;border-bottom-right-radius:20px;border-bottom-left-radius:20px;width:35%;height:15px;position:absolute;top:0;left:32.5%}.mobile-wrapper .cache-top .camera[data-v-7b6a98ec]{aspect-ratio:1;background:#ffffff4d;border-radius:50%;width:9%;max-width:10px;position:absolute;top:40%;right:5%;transform:translate(-50%,-50%)}.mobile-wrapper .cache-top .camera[data-v-7b6a98ec]:after{content:\"\";filter:blur(1px);background:#fff;border-radius:50%;width:25%;height:25%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.mobile-wrapper .buttons[data-v-7b6a98ec]{width:5px;height:20%;position:absolute;top:10%;left:-12.5px}.mobile-wrapper .button[data-v-7b6a98ec]{background:#000;border-radius:30%;width:5px;margin-bottom:10px}.mobile-wrapper .button.small[data-v-7b6a98ec]{height:15px;margin-bottom:10px}.mobile-wrapper .button.long[data-v-7b6a98ec]{height:30px}.mobile-wrapper[data-v-7b6a98ec]:first-child{border-radius:16px}"]], ["__scopeId", "data-v-7b6a98ec"]]), It = { class: "main-container" }, Lt = ["innerHTML"], Rt = ["innerHTML"], zt = /*#__PURE__*/ T(/* @__PURE__ */ D({
	__name: "TrouverMdpRs.ce",
	props: {
		titleLevel: {
			default: 2,
			type: Number
		},
		feedback: { type: Object },
		validations: { type: Object },
		userProfile: { type: Object }
	},
	setup(n, { expose: r }) {
		let { t: a } = O(), o = Qe();
		le();
		let s = e(""), c = e(), l = y(() => c.value === "success"), u = y(() => {
			if (c.value !== void 0) return l.value ? n.feedback.success : n.feedback.failed;
		}), d = y(() => u.value !== void 0 && o.phone);
		function f() {
			s.value = "", c.value = void 0;
		}
		function p() {
			c.value = void 0;
		}
		return r({ reset: f }), (e, r) => (i(), E("div", It, [
			t(pt, {
				"current-feedback-type": c.value,
				"onUpdate:currentFeedbackType": r[0] ||= (e) => c.value = e,
				password: s.value,
				"onUpdate:password": r[1] ||= (e) => s.value = e,
				"current-feedback": u.value,
				"title-level": n.titleLevel + 1,
				validations: n.validations
			}, null, 8, [
				"current-feedback-type",
				"password",
				"current-feedback",
				"title-level",
				"validations"
			]),
			t(Ft, {
				class: "mobile-shell",
				"background-color": "#fff"
			}, {
				content: C(() => [t(Pt, te(n.userProfile, { "title-level": n.titleLevel }), null, 16, ["title-level"])]),
				_: 1
			}),
			t(ue, {
				show: d.value,
				"text-button": l.value ? "" : b(a)("trouver-mdp-rs.retryButtonLabel"),
				"button-position": "center",
				class: "popin",
				onPrimaryAction: p
			}, {
				title: C(() => [_("span", { innerHTML: u.value?.title }, null, 8, Lt)]),
				content: C(() => [_("span", { innerHTML: u.value?.content }, null, 8, Rt)]),
				_: 1
			}, 8, ["show", "text-button"])
		]));
	}
}), [["styles", [".main-container[data-v-2639831f]{color:#122647;gap:32px;max-height:550px;padding-inline:.75rem;font-family:Roboto,Nunito,sans-serif;display:flex;position:relative}.mobile-shell[data-v-2639831f]{flex:1}.popin[data-v-2639831f]{display:none}@media screen and (width<=769px){.main-container[data-v-2639831f]{flex-direction:column-reverse}.mobile-shell[data-v-2639831f]{border:none;border-radius:0;flex-direction:column;gap:16px;display:flex;overflow-y:scroll}.mobile-shell[data-v-2639831f] .buttons,.mobile-shell[data-v-2639831f] .cache-top{display:none}.popin[data-v-2639831f]{display:inherit}}"]], ["__scopeId", "data-v-2639831f"]]);
//#endregion
//#region src/webcomponents/trouver-mdp-rs/trouver-mdp-rs.ce.js
k.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": de,
	"./locales/en.json": fe,
	"./locales/es-419.json": pe,
	"./locales/es.json": me,
	"./locales/fr-BE.json": he,
	"./locales/fr.json": ge,
	"./locales/it.json": _e,
	"./locales/nl.json": ve
}));
var Bt = v(zt, { configureApp(e) {
	k.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(k), e.use($e, { preset: "devices" });
} });
Bt.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: se(e.titleLevel)
}), window.customElements.define("trouver-mdp-rs", Bt);
//#endregion
